import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonConfigurationClass;
function JsonConfiguration() {
  if (JsonConfigurationClass === VOID) {
    class $ {
      constructor(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
        encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
        ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
        isLenient = isLenient === VOID ? false : isLenient;
        allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
        prettyPrint = prettyPrint === VOID ? false : prettyPrint;
        explicitNulls = explicitNulls === VOID ? true : explicitNulls;
        prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
        coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
        useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
        classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
        allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
        useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
        namingStrategy = namingStrategy === VOID ? null : namingStrategy;
        decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
        allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
        allowComments = allowComments === VOID ? false : allowComments;
        classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
        this.a2o_1 = encodeDefaults;
        this.b2o_1 = ignoreUnknownKeys;
        this.c2o_1 = isLenient;
        this.d2o_1 = allowStructuredMapKeys;
        this.e2o_1 = prettyPrint;
        this.f2o_1 = explicitNulls;
        this.g2o_1 = prettyPrintIndent;
        this.h2o_1 = coerceInputValues;
        this.i2o_1 = useArrayPolymorphism;
        this.j2o_1 = classDiscriminator;
        this.k2o_1 = allowSpecialFloatingPointValues;
        this.l2o_1 = useAlternativeNames;
        this.m2o_1 = namingStrategy;
        this.n2o_1 = decodeEnumsCaseInsensitive;
        this.o2o_1 = allowTrailingComma;
        this.p2o_1 = allowComments;
        this.q2o_1 = classDiscriminatorMode;
      }
      toString() {
        return 'JsonConfiguration(encodeDefaults=' + this.a2o_1 + ', ignoreUnknownKeys=' + this.b2o_1 + ', isLenient=' + this.c2o_1 + ', ' + ('allowStructuredMapKeys=' + this.d2o_1 + ', prettyPrint=' + this.e2o_1 + ', explicitNulls=' + this.f2o_1 + ', ') + ("prettyPrintIndent='" + this.g2o_1 + "', coerceInputValues=" + this.h2o_1 + ', useArrayPolymorphism=' + this.i2o_1 + ', ') + ("classDiscriminator='" + this.j2o_1 + "', allowSpecialFloatingPointValues=" + this.k2o_1 + ', ') + ('useAlternativeNames=' + this.l2o_1 + ', namingStrategy=' + toString(this.m2o_1) + ', decodeEnumsCaseInsensitive=' + this.n2o_1 + ', ') + ('allowTrailingComma=' + this.o2o_1 + ', allowComments=' + this.p2o_1 + ', classDiscriminatorMode=' + this.q2o_1.toString() + ')');
      }
    }
    initMetadataForClass($, 'JsonConfiguration');
    JsonConfigurationClass = $;
  }
  return JsonConfigurationClass;
}
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new (ClassDiscriminatorMode())('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new (ClassDiscriminatorMode())('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new (ClassDiscriminatorMode())('POLYMORPHIC', 2);
}
var ClassDiscriminatorModeClass;
function ClassDiscriminatorMode() {
  if (ClassDiscriminatorModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ClassDiscriminatorMode');
    ClassDiscriminatorModeClass = $;
  }
  return ClassDiscriminatorModeClass;
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
//region block: exports
export {
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance as ClassDiscriminatorMode_ALL_JSON_OBJECTS_getInstance20gwbkqe17sac,
  ClassDiscriminatorMode_NONE_getInstance as ClassDiscriminatorMode_NONE_getInstance2e818e0ikitep,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance as ClassDiscriminatorMode_POLYMORPHIC_getInstanceue6gwgg4fjtc,
  JsonConfiguration as JsonConfiguration2bv2x41u8reet,
};
//endregion

//# sourceMappingURL=JsonConfiguration.mjs.map
